import axios from "axios";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import Table from "../../Components/AddBank/Table";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import NotFoundModel from "../../Components/NotFoundModel";
import {
  Bg,
  BoxContainer,
  Underline,
  Button,
} from "../../Components/Styles/PageStyles";
import Config from "../../Config";
import Images from "../../Images";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import AddBankComp from "../../Components/AddBank/AddBank";
import LinkBankAccount from "../../Components/AddBank/LinkBankAccount";
import { MdAdd } from "react-icons/md";
import ViewDetail from "../../Components/AddBank/ViewDetail";
import EditDetails from "../../Components/AddBank/EditDetails";

function AddBankPage() {
  const location = useLocation();
  const user = useSelector((state) => state.UserReducer.user);

  const { clientId,id } = useParams();
  const [apiData, setApiData] = useState();
  const [addBankComp, setAddBankComp] = useState();
  const [selectedData, setSelectedData] = useState();
  const [linkBank, setLinkBank] = useState();
  const [viewDetail, setViewDetail] = useState(false);
  const [editDetails, setEditDetails] = useState(false);

  const fetchData = async () => {
    const body = new FormData();
    body.append("clientId", clientId);
    return await axios.post(`${Config.apiUrl}/getbankaccount`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onDataError = (data) => {};

  const onDataSuccess = (res) => {
    if (res?.data?.data?.status == "NOK") 
      error = true;
    else 
      setApiData(res.data);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      DataMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  const {
    isLoading: isDataLoading,
    mutate: DataMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchData, {
    onSuccess: onDataSuccess,
    onError: onDataError,
  });

  const onAddBankData = async (values) => {
    const body = new FormData();

    Object.keys(values).forEach((i) => body.append(i, values[i]));
    body.append("clientId", clientId);
    body.append("type", 1);
    return await axios.post(`${Config.apiUrl}/addbankaccount`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddBankSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setApiData(data?.data);
    // DataMutate();
    setAddBankComp(false);
  };

  const onAddBankError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");

    // DataMutate();
    setAddBankComp(false);
  };

  const { isLoading: addBankLoading, mutate: addBankMutate } = useMutation(
    onAddBankData,
    {
      onSuccess: onAddBankSuccess,
      onError: onAddBankError,
    }
  );

  const onAddDataUPI = async (values) => {
    const body = new FormData();

    Object.keys(values).forEach((i) => body.append(i, values[i]));
    body.append("clientId", clientId);
    body.append("type", 2);
    return await axios.post(`${Config.apiUrl}/addbankaccount`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddSuccessUPI = (data) => {
    toast.success(data?.data?.msg || "Success");
    setApiData(data.data);
    // DataMutate();
    setAddBankComp(false);
  };

  const onAddErrorUPI = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");

    // DataMutate();
    setAddBankComp(false);
  };

  const { isLoading: addUPILoading, mutate: addUPIMutate } = useMutation(
    onAddDataUPI,
    {
      onSuccess: onAddSuccessUPI,
      onError: onAddErrorUPI,
    }
  );

  const LinkBankFunction = async (checkData) => {
    const formData = new FormData();
    formData.append("clientId", clientId);

    const linkedBank = [];
    const unlinkedBank = [];
    checkData.forEach((isChecked, propId) => {
      const BankInfo = { bankId: selectedData.id, propId: propId };
      isChecked ? linkedBank.push(BankInfo) : unlinkedBank.push(BankInfo);
    });

    formData.append("linkBank", JSON.stringify(linkedBank));
    formData.append("unlinkBank", JSON.stringify(unlinkedBank));

    return await axios.post(`${Config.apiUrl}/linkunlinkbanks`, formData, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const LinkBankOnSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Success");

      setApiData(data.data);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setLinkBank(false);
    setSelectedData("");
  };

  const LinkBankOnError = (data) => {
    setLinkBank(false);
    setSelectedData("");
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: LinkBankLoading, mutate: LinkBankMutate } = useMutation(
    LinkBankFunction,
    {
      onSuccess: LinkBankOnSuccess,
      onError: LinkBankOnError,
    }
  );


//---Edit Bank Details----
const EditDetailsFunction=async(values)=>{
  const body = new FormData();
  body.append("id",values.id);
  body.append("clientId",clientId);
  body.append("bankName", values.bankName);
  body.append("accountNum", values.accountNum);
  body.append("ifsc", values.ifsc);
  body.append("holderName", values.holderName);
  body.append("bankAddress", values.bankAddress);
  body.append("payuMid", values.payuMid);
  body.append("payuKey", values.payuKey);
  body.append("isOnlineSettlement", values.isOnlineSettlement);
  body.append("easeBuzz", values.easeBuzz);
  body.append("cashFreeVid", values.cashFreeVid);

    return await axios.post(
    `${Config.apiUrl}/editbankaccount`,
    body,
    {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }
  );
}


const onEditSuccess =(data)=>{
  if(data?.data?.status === "OK"){
    toast.success(data?.data?.msg || "Success");
    setApiData(data.data);
  } else{
    toast.error(data?.data?.msg || "An Error Occured");
  }
  setEditDetails(false);
  setSelectedData("");
}

const onEditError =(data)=>{
  setEditDetails(false);
  setSelectedData("");
  toast.error(data?.response?.data?.msg || "An Error Occured");
}

const {isLoading:onEditBankLoading, mutate:onEditBankMutate}= useMutation(
  EditDetailsFunction,
  {
    onSuccess:onEditSuccess,
    onError: onEditError,
  }
)

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {"Bank Detail's"}
                <span>/{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
            {/* <button
              className="bg-primary-color text-white p-2 rounded-md flex  justify-center items-center"
              onClick={() => setAddBankComp(true)}
            >
              Add bank
            </button> */}
            <UploadWrapper>
              <Button type="button" onClick={() => setAddBankComp(true)}>
                <MdAdd className="text-white w-5 h-5" /> <p className="text-sm">{"Add bank"}</p>
              </Button>
            </UploadWrapper>
          </div>

          {linkBank && (
            <LinkBankAccount
              setLinkBank={setLinkBank}
              isLoading={LinkBankLoading}
              mutate={LinkBankMutate}
              propertyList={apiData?.properties}
              selectedData={selectedData}
            />
          )}

          {addBankComp && (
            <AddBankComp
              setAddBank={setAddBankComp}
              mutateBank={addBankMutate}
              isLoadingBank={addBankLoading}
              mutateUPI={addUPIMutate}
              isLoadingUPI={addUPILoading}
            />
          )}

          {viewDetail && (
            <ViewDetail
              setViewDetail={setViewDetail}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />
          )}

          {editDetails && (
            <EditDetails
              onEditBankLoading={onEditBankLoading}
              onEditBankMutate={onEditBankMutate}
              setEditDetails={setEditDetails}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />
          )}

          {!error && !isDataLoading && data && (
            <TableWrapper>
              <Table
                ApiData={apiData?.data}
                setSelectedData={setSelectedData}
                userType={user.userType}
                setLinkBank={setLinkBank}
                setViewDetail={setViewDetail}
                setEditDetails={setEditDetails}
              />
              {(error || apiData?.msg == "No data found") && !isDataLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isDataLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
}
const Title = tw.h1`text-xl w-full text-gray-800 whitespace-nowrap font-medium flex justift-center`;
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;

export default AddBankPage;
